import React, { useState, useContext, useEffect, useRef } from "react";
import { ModalEditCollaborationContainer, ProfileImage } from "./ModalEditCollaborationStyled";

import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import { formatNumber, getBase64, toUpperCase } from "../../services/generalSevices";
import Select from 'react-select';

import close from './../../utils/images/close_circle_outline.svg';
import back from './../../utils/images/arrow_back.svg';
import logo from './../../utils/images/name_logo_dark.svg';
import less from './../../utils/images/less.png';
import plus from './../../utils/images/plus.png';
import avatar from './../../utils/images/avatar_fluincr.png';
import tiktok from './../../utils/images/tiktok_opacity.svg';
import facebook from './../../utils/images/facebook_color.svg';
import instagram from './../../utils/images/instagram_color.svg';
import youtube from './../../utils/images/youtube_color.svg';
import twitter from './../../utils/images/twitter_color.svg';
import check from './../../utils/images/check_circle_darker.svg';
import star from './../../utils/images/star.svg';
import share from './../../utils/images/share_new.svg';
import gift from './../../utils/images/gift.svg';
import upload from './../../utils/images/upload.svg';
import shoppingCart from './../../utils/images/shopping_cart_white.svg';
import { LangContext } from "../../context/langContext";
import { UserContext } from "../../context/userContext";
import { getInfluencerData, getServicesWithNameByInfluencer } from "../../api/influencerApi";
import { getCompanyData, getInfluencerLikeFromCompany } from "../../api/companyApi";
//import { CartContext } from "../../context/cartContext";
import { deleteContentCollaboration, getContentCollaboration, postCollaboration, postContentCollaboration, putCollaboration } from "../../api/collaborationApi";
import { postFileBase64 } from "../../api/fileApi";
import Spinner from "../Spinner/Spinner";
import SocialMedia from "../SocialMedia/SocialMedia";
import { CurrencyContext } from "../../context/currencyContext";
import { getConvertCurrency } from "../../api/exchangeApi";
import LikeInfluencer from "../LikeInfluencer/LikeInfluencer";
import SelectProduct from "../SelectProduct/SelectProduct";


export default function ModalEditCollaboration({ setShowEditCollaboration, collaborationData }) {

    const shareRef = useRef(null);
    const { locale } = useContext(LangContext);
    const { id, companyId, products, userType, userToken, uniqueName, account } = useContext(UserContext);
    const { currency } = useContext(CurrencyContext);

    const navigate = useNavigate();
    const intl = useIntl();

    const [isLoading, setIsLoading] = useState(false);

    const [profileImage, setProfileImage] = useState('');
    const [influencerId, setInfluencerId] = useState(null);
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [rating, setRating] = useState(null);
    const [city, setCity] = useState('');
    const [country, setCountry] = useState({})
    const [languages, setLanguages] = useState([]);
    const [categories, setCategories] = useState([]);
    const [categoriesName, setCategoriesName] = useState([]);
    const [categoriesNombre, setCategoriesNombre] = useState([]);
    const [verified, setVerified] = useState(false);

    const [sendGift, setSendGift] = useState(false);

    const [isFavorite, setIsFavorite] = useState(false);

    const [productsOptions, setProductsOptions] = useState([{ label: 'Shampo', value: 'sham' }, { label: 'Shampo', value: 'sham' }, { label: 'Shampo', value: 'sham' }])

    const [showCommentsArea, setShowCommentsArea] = useState(false);

    const [showTiktok, setShowTiktok] = useState(false);
    const [showInstagram, setShowInstagram] = useState(false);
    const [showFacebook, setShowFacebook] = useState(false);
    const [showTwitter, setShowTwitter] = useState(false);
    const [showYoutube, setShowYoutube] = useState(false);

    const [quantityPhoto, setQuantityPhoto] = useState(0);
    const [initialQuantityPhoto, setInitialQuantityPhoto] = useState(0);
    const [initialIdPhoto, setInitialIdPhoto] = useState([]);
    const [pricePhoto, setPricePhoto] = useState(null);
    const [auxPricePhoto, setAuxPricePhoto] = useState(null);

    const [quantityVideo30, setQuantityVideo30] = useState(0);
    const [initialQuantityVideo30, setInitialQuantityVideo30] = useState(0);
    const [initialIdVideo30, setInitialIdVideo30] = useState([]);
    const [priceVideo30, setPriceVideo30] = useState(null);
    const [auxPriceVideo30, setAuxPriceVideo30] = useState(null);
    const [quantityVideo60, setQuantityVideo60] = useState(0);
    const [initialQuantityVideo60, setInitialQuantityVideo60] = useState(0);
    const [initialIdVideo60, setInitialIdVideo60] = useState([]);
    const [priceVideo60, setPriceVideo60] = useState(null);
    const [auxPriceVideo60, setAuxPriceVideo60] = useState(null);

    const [quantityVideoPlus, setQuantityVideoPlus] = useState(0);
    const [initialQuantityVideoPlus, setInitialQuantityVideoPlus] = useState(0);
    const [initialIdVideoPlus, setInitialIdVideoPlus] = useState([]);
    const [priceVideoPlus, setPriceVideoPlus] = useState(null);
    const [auxPriceVideoPlus, setAuxPriceVideoPlus] = useState(null);

    const [comments, setComments] = useState('');
    const [base64File, setBase64File] = useState('');
    const [promotionalCode, setPromocionalCode] = useState('');

    const [productId, setProductId] = useState(null);
    const [productName, setProductName] = useState(null);
    const [productImage, setProductImage] = useState(null);
    const [productPrice, setProductPrice] = useState(null);
    const [auxProductPrice, setAuxProductPrice] = useState(null);
    const [collaborationTotal, setCollaborationTotal] = useState(null);
    const [auxCollaborationTotal, setAuxCollaborationTotal] = useState(null);

    const [disabled, setDisabled] = useState(true);

    const [showNotServices, setShowNotServices] = useState(false);


    const [showSocialMedia, setShowSocialMedia] = useState(false);
    //const url = `http://localhost:3000/${collaborationData.influincr.username}`;
    const url = `http://localhost:3000/`;

    const [selectedProduct, setSelectedProduct] = useState();
    const newCollaborationBody = Object.assign(collaborationData);
    const auxCurrency = currency.symbol;

    const [influencerServices, setInfluencerServices] = useState([]);

    const [influencerTiktok, setInfluencerTiktok] = useState();
    const [influencerInstagram, setInfluencerInstagram] = useState();
    const [influencerFacebook, setInfluencerFacebook] = useState();
    const [influencerTwitter, setInfluencerTwitter] = useState();
    const [influencerYoutube, setInfluencerYoutube] = useState();

    const [typeRemove, setTypeRemove] = useState([]);

    useEffect(() => {
        if (collaborationData !== null) {
            setIsLoading(true);
            getServicesWithNameByInfluencer({ influencerId: collaborationData.influincr.id }).then((response) => {
                let auxServices = [...response];

                const newServices = response.map(async (service, index) => {

                    for (let i = 0; i < collaborationData.item.length; i++) {
                        if (JSON.parse(collaborationData.item[i].title).name === service.services.name) {
                            auxServices[index].quantity = collaborationData.item[i].quantity;
                            break;
                        } else {
                            auxServices[index].quantity = 0;
                        }
                    }

                    return await getConvertCurrency({ amount: service.rate }).then((responseRate) => {
                        auxServices[index].currency = Number(responseRate[auxCurrency]).toFixed(0);
                    })
                })

                Promise.all(newServices).then(() => {
                    setInfluencerServices(auxServices)
                    setIsLoading(false);
                })
            })
        }
    }, [])


    const addQuantity = (index) => {
        let auxServices = [...influencerServices];
        auxServices[index].quantity = auxServices[index].quantity + 1;
        setInfluencerServices(auxServices)
        for (let i = 0; i < newCollaborationBody.item.length; i++) {
            // Comprobar si el objeto tiene el título dado
            if (newCollaborationBody.item[i].title === JSON.stringify(auxServices[index].services)) {
                // Cambiar la cantidad del objeto
                newCollaborationBody.item[i].quantity = auxServices[index].quantity;
            }
        }
        newCollaborationBody.item.push({
            title: JSON.stringify(auxServices[index].services),
            price: auxServices[index].rate,
            status: 0,
            content: "empty",
            quantity: auxServices[index].quantity,
            readCompany: false,
            readInfluencer: false,
        })

        newCollaborationBody.items = newCollaborationBody.item;
    }

    const removeQuantity = (index) => {
        let auxServices = [...influencerServices];
        if (auxServices[index].quantity > 0) {
            auxServices[index].quantity = auxServices[index].quantity - 1;
        }
        setTypeRemove([...typeRemove, auxServices[index].services])
        setInfluencerServices(auxServices)
    }

    useEffect(() => {
        if (companyId !== -1) {
            getInfluencerLikeFromCompany({ companyId: companyId }).then((response) => {
                const likes = response
                const favorite = likes.some((element) => element.influincridlike
                    === collaborationData.influincr.id)
                setIsFavorite(favorite)
            })
        }
    }, [companyId, collaborationData])

    useEffect(() => {

        const auxProducts = []
        products.map((product) => {
            auxProducts.push({ label: product.name, value: product.id, price: product.price?.USD, image: product.image })
        })
        setProductsOptions(auxProducts)

        setSelectedProduct({ label: collaborationData.product.name, value: collaborationData.product.id, price: collaborationData.product.price?.USD, image: collaborationData.product.image })
        setCollaborationTotal(collaborationData.totalPrice);

        getConvertCurrency({ amount: collaborationData.totalPrice }).then((response) => {
            //setAuxCollaborationTotal(response[auxCurrency].toFixed(0))
            setAuxCollaborationTotal(response[auxCurrency].toFixed(2))
        })

        setProductName(collaborationData.product.name);
        setProductPrice(collaborationData.giftValue);
        getConvertCurrency({ amount: collaborationData.giftValue }).then((response) => {
            //setAuxProductPrice(response[auxCurrency].toFixed(0))
            setAuxProductPrice(response[auxCurrency].toFixed(2))
        })

        setSendGift(collaborationData.gift);

        setComments(collaborationData.comment)


        setProfileImage(collaborationData.influincr.imageProfile);
        setInfluencerId(collaborationData.influincr.id);
        setName(collaborationData.influincr.givenName)
        setLastName(collaborationData.influincr.familyName)
        setCity(collaborationData.influincr.city);
        setCountry(collaborationData.influincr.country);

        setRating(collaborationData.influincr.rating);

        const auxLanguages = [];
        collaborationData.influincr.language?.map((language) => {
            auxLanguages.push(language.languageId.convention)
        })
        setLanguages(auxLanguages)

        const auxCategories = [];
        const auxCategoriesNombre = [];
        collaborationData.influincr.category?.map((category) => {
            auxCategories.push(category.categoryId.name);
            auxCategoriesNombre.push(category.categoryId.nombre)
        })
        setCategories(auxCategories)
        setCategoriesName(auxCategories);
        setCategoriesNombre(auxCategoriesNombre);

        setVerified(collaborationData.influincr.attributes.verified)
        setProductPrice(collaborationData.product.price.USD)

        getConvertCurrency({ amount: collaborationData.product.price.USD }).then((response) => {
            //setAuxProductPrice(response[auxCurrency].toFixed(0))
            setAuxProductPrice(response[auxCurrency].toFixed(2))
        })
        setProductId(collaborationData.product.id);

        setInfluencerTiktok(collaborationData.influincr.followers?.tiktok);
        setInfluencerInstagram(collaborationData.influincr.followers?.instagram);
        setInfluencerFacebook(collaborationData.influincr.followers?.facebook);
        setInfluencerTwitter(collaborationData.influincr.followers?.twitter);
        setInfluencerYoutube(collaborationData.influincr.followers?.youtube);

    }, [])


    useEffect(() => {
        getInfluencerData({ userName: collaborationData.influincr.username }).then((response) => {

            setProfileImage(response.imageProfile);
            setInfluencerId(response.id);
            setName(response.givenName)
            setLastName(response.familyName)
            setCity(response.city);
            setCountry(response.country);

            setRating(response.rating);

            const auxLanguages = [];
            response.language?.map((language) => {
                auxLanguages.push(language.languageId.convention)
            })
            setLanguages(auxLanguages)

            const auxCategories = [];
            response.category?.map((category) => {
                auxCategories.push(category.categoryId.name)
            })
            setCategories(auxCategories)

            /* if (response.personalFare.photo !== null && response.personalFare.photo !== 0) {
                getConvertCurrency({ amount: response.personalFare?.photo }).then((response) => {
                    setAuxPricePhoto(response[auxCurrency].toFixed(0))
                })
            }
            if (response.personalFare.video30 !== null && response.personalFare.video30 !== 0) {
                getConvertCurrency({ amount: response.personalFare?.video30 }).then((response) => {
                    setAuxPriceVideo30(response[auxCurrency].toFixed(0))
                })
            }
            if (response.personalFare.video60 !== null && response.personalFare.video60 !== 0) {
                getConvertCurrency({ amount: response.personalFare?.video60 }).then((response) => {
                    setAuxPriceVideo60(response[auxCurrency].toFixed(0))
                })
            }
            if (response.personalFare.videoPlus !== null && response.personalFare.videoPlus !== 0) {
                getConvertCurrency({ amount: response.personalFare?.videoPlus }).then((response) => {
                    setAuxPriceVideoPlus(response[auxCurrency].toFixed(0))
                })
            } */

            /* if (Object.keys(response?.personalFare) < 1) {
                setShowNotServices(true);
            } */

            setVerified(response.attributes.verified)
        })
    }, [])

    useEffect(() => {
        if (collaborationTotal !== null) {
            getConvertCurrency({ amount: collaborationTotal }).then((response) => {
                //setAuxCollaborationTotal(response[auxCurrency].toFixed(0))
                setAuxCollaborationTotal(response[auxCurrency].toFixed(2))
            })
        }
    }, [collaborationTotal])


    useEffect(() => {

        if (productName !== null) {
            for (let i = 0; i < influencerServices.length; i++) {
                if (influencerServices[i].quantity > 0) {
                    setDisabled(false);
                    break;
                } else {
                    setDisabled(true)
                }
            }
        } else {
            setDisabled(true)
        }

    }, [influencerServices, productName])


    useEffect(() => {

        let total = 0;
        influencerServices.map((service) => {
            total = total + (service.rate * service.quantity)
        })

        if (sendGift) {
            if (productPrice !== null) {
                if (productPrice < total) {
                    total = total - productPrice;
                } else {
                    total = 0;
                }
            }
        }

        setCollaborationTotal(total);
    }, [influencerServices, sendGift, productPrice])

    const onSelectproduct = (event) => {
        setSelectedProduct(event)
        setProductId(event.value)
        setProductPrice(event.price)
        setProductName(event.label)
        setProductImage(event.image)
        getConvertCurrency({ amount: event.price }).then((response) => {
            //setAuxProductPrice(response[auxCurrency].toFixed(0))
            setAuxProductPrice(response[auxCurrency].toFixed(2))
        })
    }


    const editCollaboration = () => {

        setIsLoading(true);

        delete newCollaborationBody.company;
        delete newCollaborationBody.cover;
        delete newCollaborationBody.creation;
        newCollaborationBody.idInfluencer = collaborationData.influincr.id;
        delete newCollaborationBody.influincr;
        newCollaborationBody.idProduct = productId;
        delete newCollaborationBody.product;
        delete newCollaborationBody.rateCompany;
        delete newCollaborationBody.rateInfluencer;
        delete newCollaborationBody.trackingNumber;

        newCollaborationBody.comment = comments;
        newCollaborationBody.totalPrice = collaborationTotal;
        newCollaborationBody.gift = sendGift;
        newCollaborationBody.giftValue = productPrice;


        newCollaborationBody.item.map((content, index) => {
            delete newCollaborationBody.item[index].dateStatusTime;
            delete newCollaborationBody.item[index].colaboration;


            for (let i = 0; i < influencerServices.length; i++) {

                if (JSON.parse(content.title).name === influencerServices[i].services.name) {

                    if (newCollaborationBody.item[index].quantity < influencerServices[i].quantity) {
                        //agregar
                        newCollaborationBody.item[index].quantity = influencerServices[i].quantity;


                    } else if (newCollaborationBody.item[index].quantity > influencerServices[i].quantity) {
                        //quitar
                        newCollaborationBody.item[index].quantity = influencerServices[i].quantity;
                    }

                }
            }
        })

        newCollaborationBody.item.reverse().map((content, index) => {
            typeRemove.map((type, indextype) => {
                if (type.name === JSON.parse(content.title).name) {
                    let auxType = [...typeRemove];
                    auxType.splice(indextype, 1);
                    setTypeRemove(auxType);
                }
            })
        })

        newCollaborationBody.item.reverse();
        typeRemove.map((type, index) => {

            for (let i = 0; i < newCollaborationBody.item.length; i++) {

                if (JSON.parse(newCollaborationBody.item[i].title).name === type.name) {
                    if (Object.keys(newCollaborationBody.item[i]).some(x => x === 'id')) {
                        deleteContentCollaboration({ contentId: newCollaborationBody.item[i].id })
                    }
                    newCollaborationBody.item.splice(i, 1)
                    break;
                }
            }

        })

        newCollaborationBody.items = newCollaborationBody.item;

        if (base64File !== '') {

            const fileBody = {
                base64File: base64File.base64.split(',')[1],
                formatFile: base64File.type,
                address: `company/${account}/collaboration`
            }
            postFileBase64({ body: fileBody, token: userToken }).then((responseFile) => {

                if (responseFile.length > 0) {

                    newCollaborationBody.document = responseFile

                    putCollaboration({ collaborationBody: newCollaborationBody, token: userToken }).then((response) => {
                        setIsLoading(false);
                        setShowEditCollaboration(false);

                    })

                }
            })
        } else {
            putCollaboration({ collaborationBody: newCollaborationBody, token: userToken }).then((response) => {
                setIsLoading(false);
                setShowEditCollaboration(false);
            })
        }

    }


    /* const selectProductsStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '30px', minHeight: '34px', flexWrap: 'no-wrap', minWidth: '150px'

        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({ ...styles }),
        placeholder: (styles) => ({ ...styles, fontSize: '1rem', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }),
        singleValue: (styles) => ({ ...styles, fontSize: '1rem' }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        })
    }; */

    useEffect(() => {
        function handleClickOutside(event) {

            if (shareRef.current && !shareRef.current.contains(event.target)) {
                setShowSocialMedia(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [shareRef])

    return (
        <ModalEditCollaborationContainer>

            <img src={close} alt="close" className="close" onClick={() => { setShowEditCollaboration(false) }} />

            <div className="collaborationBody">

                <div className="goBack" onClick={() => { setShowEditCollaboration(false) }}>
                    <img src={back} alt="back" className="backIcon" />
                    <p className="backText" ><FormattedMessage id="go_back" defaultMessage="ir atrás" /></p>
                </div>
                <h3 className="mobileTitle"><FormattedMessage id="create_collaboration_title" defaultMessage="Crea tu colaboración " /> <img src={logo} alt="logo" className="logo" /></h3>

                <div className="influencerData">

                    <div className="profile">

                        <div className="likeProfile">
                            {(userType === 'company' || userToken === null) && (<LikeInfluencer profileId={influencerId} isFavorite={isFavorite} setIsFavorite={setIsFavorite} />)}
                        </div>
                        <ProfileImage image={(profileImage !== '' && profileImage !== null) ? profileImage : avatar} />

                        <div className="networks">

                            {(influencerTiktok !== undefined) && (<div className="network">
                                <img src={tiktok} alt="tiktok" className="networkIcon" onMouseOver={() => { setShowTiktok(true) }} onMouseOut={() => { setShowTiktok(false) }} />
                                {(showTiktok) && (<p>{(influencerTiktok < 999) ? influencerTiktok : (influencerTiktok < 999999) ? `${(influencerTiktok / 1000).toFixed(1)} k` : `${(influencerTiktok / 1000000).toFixed(1)} m`}</p>)}
                            </div>)}

                            {(influencerInstagram !== undefined) && (<div className="network">
                                <img src={instagram} alt="instagram" className="network" onMouseOver={() => { setShowInstagram(true) }} onMouseOut={() => { setShowInstagram(false) }} />
                                {(showInstagram) && (<p>{(influencerInstagram < 999) ? influencerInstagram : (influencerInstagram < 999999) ? `${(influencerInstagram / 1000).toFixed(1)} k` : `${(influencerInstagram / 1000000).toFixed(1)} m`}</p>)}

                            </div>)}

                            {(influencerFacebook !== undefined) && (<div className="network">
                                <img src={facebook} alt="facebook" className="network" onMouseOver={() => { setShowFacebook(true) }} onMouseOut={() => { setShowFacebook(false) }} />
                                {(showFacebook) && (<p>{(influencerFacebook < 999) ? influencerFacebook : (influencerFacebook < 999999) ? `${(influencerFacebook / 1000).toFixed(1)} k` : `${(influencerFacebook / 1000000).toFixed(1)} m`}</p>)}
                            </div>)}

                            {(influencerTwitter !== undefined) && (<div className="network">
                                <img src={twitter} alt="twitter" className="network" onMouseOver={() => { setShowTwitter(true) }} onMouseOut={() => { setShowTwitter(false) }} />
                                {(showTwitter) && (<p>{(influencerTwitter < 999) ? influencerTwitter : (influencerTwitter < 999999) ? `${(influencerTwitter / 1000).toFixed(1)} k` : `${(influencerTwitter / 1000000).toFixed(1)} m`}</p>)}
                            </div>)}

                            {(influencerYoutube !== undefined) && (<div className="network">
                                <img src={youtube} alt="youtube" className="network" onMouseOver={() => { setShowYoutube(true) }} onMouseOut={() => { setShowYoutube(false) }} />
                                {(showYoutube) && (<p>{(influencerYoutube < 999) ? influencerYoutube : (influencerYoutube < 999999) ? `${(influencerYoutube / 1000).toFixed(1)} k` : `${(influencerYoutube / 1000000).toFixed(1)} m`}</p>)}
                            </div>)}
                        </div>
                        <button className="seeProfile" onClick={() => { navigate(`/${collaborationData.influincr.username}`) }}>
                            <FormattedMessage id="create_collaboration_text_8" defaultMessage="Ver perfil" />
                        </button>
                    </div>
                    <div className="dataProfile">
                        <div className="fileName">
                            <p className="name">{(toUpperCase({ fullName: `${name.split(' ')[0]} ${(name.split(' ')[1] !== undefined) ? (name.split(' ')[1]?.charAt(0)) : ('')} ${lastName.split(' ')[0]}` }))}
                            </p>

                            {(verified) && (<img src={check} alt="check" className="check" />)}

                            <div className="subItem"><p className="score">{(rating === null) ? 'N/R' : rating}</p><img src={star} alt="star" className="star" /></div>
                        </div>
                        <div className="fileCountry">
                            <p className="city">
                                {(city !== null) && (<p>
                                    {(locale === 'es-CO') ? country?.nombre : country?.name},
                                    {` ${city}`}
                                </p>)
                                }
                            </p>
                            <p className="languages"> {languages.map((lang, index) => {
                                if (index < 1) {
                                    return (lang)
                                } else {
                                    return (`/ ${lang}`)
                                }
                            })}</p>
                            {/* <img src={share} alt="edit" className="share" /> */}
                            <div className="share" ref={shareRef}>
                                <img src={share} alt="edit" className="shareIcon" onClick={() => { setShowSocialMedia(!showSocialMedia) }} />
                                {(showSocialMedia) && (<SocialMedia shareUrl={url} />)}
                            </div>
                        </div>
                        <p className="fileCategories">
                            {(locale === 'es-CO') ? ((categories[0] !== '') && (<p>
                                {categoriesNombre.map((categ, index) => {
                                    if (index < 4) {
                                        return `#${categ} `
                                    }
                                })}
                            </p>)) : ((categories[0] !== '') && (<p>
                                {categoriesName.map((categ, index) => {
                                    if (index < 4) {
                                        return `#${categ} `
                                    }
                                })}
                            </p>))}
                        </p>

                    </div>


                </div>

                <div className="collaborationData">
                    <div className="collaborationQuantity">

                        <div className="quantity">
                            <h3><FormattedMessage id="create_collaboration_title" defaultMessage="Crea tu colaboración" /> <img src={logo} alt="logo" className="logo" /></h3>

                            <SelectProduct onSelect={(event) => onSelectproduct(event)} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} />

                            {(showNotServices) && (<div className="notServices"><p><FormattedMessage id="create_collaboration_text_1" defaultMessage="El influencer no tiene ningún servicio" /></p></div>)}

                            {influencerServices.map((service, index) => {
                                return (
                                    <div className="file">
                                        <p className="type">{(locale === 'es-CO') ? service.services.nombre : service.services.name}</p>
                                        <div className="right">
                                            <div className="buttons">
                                                <button onClick={() => { removeQuantity(index) }}><img src={less} alt="less" className="addIcon" /></button>
                                                <span>{service.quantity}</span>
                                                <button onClick={() => { addQuantity(index) }}>
                                                    <img src={plus} alt="add" className="addIcon" />
                                                </button>
                                            </div>
                                            <p className="price">{currency.symbol} {formatNumber(service.currency)}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="aditionalInfo">
                            <hr />
                            <div className="giftContainer">
                                <div className="giftInfo">
                                    <input type="checkbox" name="" id="" className="giftCheckbox" checked={sendGift} onChange={(event) => { setSendGift(event.target.checked) }} />
                                    <img src={gift} alt="gift" className="giftIcon" />
                                    <span className="giftText"><FormattedMessage id="create_collaboration_text_2" defaultMessage="Envio completo del producto al influencer" /></span>
                                </div>
                                <p className="giftPrice">{(productPrice !== null) && `(${currency.symbol} -${formatNumber(auxProductPrice)})`}</p>
                            </div>

                            <div className="commentContainer">
                                <div className="addComments">
                                    <button onClick={() => { setShowCommentsArea(!showCommentsArea) }}>
                                        <img src={plus} alt="add" className="plusIcon" />
                                    </button>
                                    <p className="commentText"><FormattedMessage id="create_collaboration_text_3" defaultMessage="Comentarios/ Agregar archivo" /></p>
                                </div>
                                {(showCommentsArea) && (
                                    <div className="comments">
                                        <textarea name="" id="" cols="30" rows="10" value={comments} onChange={(event) => { setComments(event.target.value) }}></textarea>

                                        <label htmlFor="edit-collaboration-file-input" className="fileLabel">
                                            <img src={upload} alt="upload" className="uploadIcon" />
                                        </label>
                                        <input type="file" id="edit-collaboration-file-input" accept=".pdf, .txt, application/pdf, .doc, .docx, application/msword, .xls,.xlsx, application/vnd.ms-excel, .ppt, .pptx, application/vnd.ms-powerpoint, text/plain,.png, .jpg, .jpeg, image/png, image/jpg" onChange={(e) => {

                                            getBase64({ file: e.target.files[0] }).then((data) => {
                                                setBase64File({ base64: data, name: e.target.files[0].name, /* type: e.target.files[0].type.split('/')[1] */ type: e.target.files[0].name.split('.').reverse()[0] });
                                            }
                                            );
                                        }} />
                                    </div>
                                )}
                            </div>

                            {/* <p className="promotionalTitle"><FormattedMessage id="create_collaboration_text_4" defaultMessage="Gift card y código promocional" /></p>
                    <div className="promotionalInputContainer">
                        <input type="text" placeholder={intl.formatMessage({ id: "create_collaboration_text_5" })} value={promotionalCode} onChange={(event) => setPromocionalCode(event.target.value)} />
                        <button><FormattedMessage id="create_collaboration_text_6" defaultMessage="Aplicar" /></button>
                    </div> */}


                            <button className={`addShoppingCart ${disabled && 'disabledButton'}`} onClick={editCollaboration} disabled={disabled}>
                                <span><FormattedMessage id="create_collaboration_text_7" defaultMessage="Añadir al carrito" />
                                    <img src={shoppingCart} alt="shopping cart" className="cart" /></span>
                                <span> {currency.symbol} {(collaborationTotal) && formatNumber(auxCollaborationTotal)}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {(isLoading) && (<Spinner />)}
        </ModalEditCollaborationContainer>
    )
}